import {Component} from '@angular/core';
import {QueryService} from '@pt/api-client';
import {ActionsSubject, Store} from '@ngrx/store';
import {AbstractWidgetDirective} from '../../abstract-widget.directive';
import {UiWidget, WidgetConfiguration} from '@pt/pt-models';
import {TranslateService} from '@ngx-translate/core';
import {WidgetDialogService} from '../../../services/widget-dialog.service';
import {NgxPermissionsService} from 'ngx-permissions';

@Component({
  selector: 'pt-widget-html-v0',
  template: `
    <div [ngClass]="{'widget-disabled' : (internalStatus.isDisabled)}" *ngIf="internalStatus.enabled">

      <ng-container *ngIf='!internalStatus.showOptButton'>

        <pt-widget-html-v0-preview
          *ngIf="internalStatus.viewMode === 'PREVIEW' || internalStatus.viewMode === 'LOADING' || internalStatus.viewMode === 'EDIT'"
          [noDataLabel]="noDataLabel"
          [loading]='internalStatus.isLoading'
          [showNoData]='widget?.editable'
          [previewData]='previewData'>
        </pt-widget-html-v0-preview>

        <pt-widget-error
          *ngIf="internalStatus.viewMode === 'ERROR'"
          [errorMessage]='internalStatus.errorMessage | async'>
        </pt-widget-error>

        <pt-widget-footer></pt-widget-footer>
      </ng-container>
    </div>
  `
})
export class WidgetHtmlV0Component extends AbstractWidgetDirective<string> {

  constructor(public store: Store,
              public actionsSubject: ActionsSubject,
              public translateService: TranslateService,
              public widgetDialogService: WidgetDialogService,
              public service: QueryService,
              public permissionService: NgxPermissionsService) {
    super(store, actionsSubject, translateService, widgetDialogService, permissionService);
  }


  loadWidget(widget: UiWidget): void {
    this.dispatchInitState();
    this.isValid$.next(true);
    this.dispatchCompleteState(widget.value);
  }

  saveWidget(ignoreTrigger?: boolean): void {
    const widget = JSON.parse(JSON.stringify(this.widget)) as UiWidget;
    widget.comment = this.comment;
    this.completeSaveWidget(widget, ignoreTrigger);
  }

  configuration(): WidgetConfiguration {
    return {supportAutoSave: true, supportValidation: false};
  }
}
